import {Component, OnInit, ChangeDetectionStrategy, afterNextRender} from '@angular/core';
import {ArticleService} from '@services/article.service';
import {NewsCardComponent} from '@components/news-card/news-card.component';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {PageSelectorComponent} from '@/app/shared/components/page-selector/page-selector.component';
import {CheckboxComponent} from '@/app/shared/components/checkbox/checkbox.component';
import {ToastService} from '@services/toast.service';
import {Title} from '@angular/platform-browser';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {NoContentComponent} from '@/app/shared/components/no-content/no-content.component';
import {ArticleTiny, ArticleType} from '@/app/core/models/article';

@Component({
  selector: 'app-news',
	imports: [
		NewsCardComponent,
		TitleComponent,
		PageSelectorComponent,
		CheckboxComponent,
		TranslatePipe,
		LastVideosComponent,
		NoContentComponent,
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './news.component.html',
})
export class NewsComponent implements OnInit {

	constructor(
		private readonly articleService: ArticleService,
		private readonly toastService: ToastService,
		private readonly titleService: Title,
		private readonly translate: TranslateService
	) {
		// afterNextRender ne s'exécute jamais côté serveur : accès à window sûr en SSR.
		afterNextRender(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
	}

	protected readonly ArticleType = ArticleType;

	articles: ArticleTiny[] = [];
	page: number = 0;
	totalPages: number = 0;
	filter: ArticleType[] = [ArticleType.TEAM_PEPS, ArticleType.MARVEL_RIVALS, ArticleType.OVERWATCH, ArticleType.POKEMON_VGC, ArticleType.POKEMON_UNITE, ArticleType.DOFUS];

	ngOnInit(): void {
		this.loadArticles();
	}

	loadArticles(): void {
		this.articleService.getArticles(this.page, this.filter.toSorted((a, b) => a.localeCompare(b))).subscribe(response => {
			this.articles = response.content;
			this.totalPages = response.totalPages;
		});
	}

	onPageChange(newPage: number) {
		this.page = newPage;
		this.loadArticles();
	}

	filterArticles(articleTypes: ArticleType[], checked: boolean): void {
		if (checked) {
			const toAdd = articleTypes.filter(t => !this.filter.includes(t));
			if (toAdd.length) {
				this.filter = [...this.filter, ...toAdd];
			}
		} else {
			const updatedFilter = this.filter.filter(t => !articleTypes.includes(t));
			if (updatedFilter.length === 0) {
				this.filter = [ArticleType.TEAM_PEPS];
				this.toastService.show(this.translate.instant('page.news.filter-toast'), 'info');
				this.loadArticles();
				return;
			}
			this.filter = updatedFilter;
		}

		this.loadArticles();
	}

}
